import { CodeHighlightAdapterProvider, createShikiAdapter } from "@mantine/code-highlight";
import { ColorSchemeScript, MantineProvider } from "@mantine/core";
import { DatesProvider } from "@mantine/dates";
import { Notifications } from "@mantine/notifications";

import { DATE_SETTINGS, MANTINE_THEME, NOTIFICATION_SETTINGS } from "@/lib/Mantine";

import "@mantine/core/styles.css";
import "@mantine/dates/styles.css";
import "@mantine/notifications/styles.css";

import "@mantine/code-highlight/styles.css";
import "@mantine/dropzone/styles.css";
import "@mantine/tiptap/styles.css";

// Shiki requires async code to load the highlighter
async function loadShiki() {
  const { createHighlighter } = await import("shiki");
  const shiki = await createHighlighter({
    langs: ["tsx", "scss", "html", "bash", "json"],
    // You can load supported themes here
    themes: []
  });

  return shiki;
}
const shikiAdapter = createShikiAdapter(loadShiki);

export function MantineProviders({ children }: { children: React.ReactNode }) {
  return (
    <>
      <ColorSchemeScript defaultColorScheme="auto" />

      <MantineProvider theme={MANTINE_THEME}>
        <CodeHighlightAdapterProvider adapter={shikiAdapter}>
          <DatesProvider settings={DATE_SETTINGS}>
            {children}
            <Notifications {...NOTIFICATION_SETTINGS} />
          </DatesProvider>
        </CodeHighlightAdapterProvider>
      </MantineProvider>
    </>
  );
}
